import { useRecoilState } from 'recoil';
import { Store } from '../store';

export const useColors = () => {
  const [colors, setColors] = useRecoilState(Store.colorsSettings);
  return { colors, setColors };
};
